'use client'

import { Typography } from '@mui/material'
import { keyframes, styled } from '@mui/material/styles'
import { useTranslations } from 'next-intl'

import { emphasiseVerb } from '../turn/StepLabel'

const slide = keyframes`
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
`

const ShimmerText = styled(Typography)(({ theme }) => ({
  display: 'inline-block',
  backgroundImage: `linear-gradient(90deg, ${theme.palette.text.secondary} 0%, ${theme.palette.text.primary} 50%, ${theme.palette.text.secondary} 100%)`,
  backgroundSize: '200% 100%',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
  animation: `${slide} 2s linear infinite`
}))

/** A muted, shimmering "Thinking" line for a turn that is waiting on the model. */
export default function ThinkingShimmer() {
  const t = useTranslations('features.AssistantV2')
  return (
    <ShimmerText variant="body2" role="status" data-testid="assistant-thinking">
      {t.rich('thinking', { verb: emphasiseVerb })}
    </ShimmerText>
  )
}
